import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { doc, setDoc, serverTimestamp, getDoc, updateDoc } from "firebase/firestore";
import { db, auth, provider } from "../../firebase";
import { generateUsername } from "../../utils/usernameGenerator";
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    mixpanel.track("Login Page Viewed");
  }, []);

  const signIn = async () => {
    mixpanel.track("Login Clicked");
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const userRef = doc(db, "subusers", user.uid);
    const userSnap = await getDoc(userRef);
    const isNewUser = !userSnap.exists()

    if (!userSnap.exists()) {
      let newUsername = generateUsername();

      await setDoc(userRef, {
        username: newUsername,
        email: user.email,
        createdAt: serverTimestamp(),
        savedSubs: [],
        userId: user.uid
      });
    } else {
      await updateDoc(userRef, {
        email: user.email
      });
    }

    mixpanel.track("Login Success", {
      is_new_user: isNewUser
    });

    navigate("/");
  };

  return (
    <div style={styles.page}>
      <div style={styles.gradientOrb1} />
      <div style={styles.gradientOrb2} />

      <Container style={styles.container}>
        <div style={styles.card}>
          
          {/* HERO */}
          <div style={styles.hero}>
            <div style={styles.title}>
              Subliminals can be fun too.
            </div>

            <div style={styles.subtitle}> 
              Something you actually *want* to come back to.
            </div>
          </div>

          {/* VISUAL DIVIDER */}
          <div style={styles.divider} />

          {/* BENEFITS */}
          <div style={styles.features}>
            
            <Feature
              emoji="🎯"
              title="One Click Remix"
              text="Remix any subs to fit your unique need."
            />
            <Feature
              emoji="🧠"
              title="Discover Powerful Subs"
              text="Swipe through subs by creators."
            />
            <Feature
              emoji="🔥"
              title="Make Playlists"
              text="Combine powerful subs in one playlist."
            />
          </div>

          {/* CTA */}
          <button onClick={signIn} style={styles.cta}>
            Make fun subliminals →
          </button>

          <div style={styles.microcopy}>
            Takes 2 seconds. No setup.
          </div>

        </div>
      </Container>
    </div>
  );
}

function Feature({ emoji, title, text }) {
  return (
    <div style={styles.feature}>
      <div style={styles.featureIcon}>{emoji}</div>
      <div>
        <div style={styles.featureTitle}>{title}</div>
        <div style={styles.featureText}>{text}</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#050505",
    position: "relative",
    overflow: "hidden",
    fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
    color: "white"
  },

  container: {
    maxWidth: "480px",
    zIndex: 2
  },

  card: {
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(24px)",
    borderRadius: "28px",
    padding: "44px 30px",
    boxShadow: "0 30px 80px rgba(0,0,0,0.6)",
    border: "1px solid rgba(255,255,255,0.08)",
    textAlign: "center"
  },

  hero: {
    marginBottom: "28px"
  },

  title: {
    fontSize: "34px",
    fontWeight: 700,
    letterSpacing: "-0.8px",
    lineHeight: 1.2
  },

  subtitle: {
    marginTop: "12px",
    fontSize: "15px",
    color: "rgba(255,255,255,0.6)",
    lineHeight: 1.5
  },

  divider: {
    height: "1px",
    background: "rgba(255,255,255,0.08)",
    margin: "24px 0"
  },

  features: {
    marginBottom: "30px"
  },

  feature: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "18px",
    textAlign: "left"
  },

  featureIcon: {
    fontSize: "18px",
    marginTop: "2px"
  },

  featureTitle: {
    fontSize: "14px",
    fontWeight: 600
  },

  featureText: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.5)"
  },

  cta: {
    width: "100%",
    padding: "16px",
    borderRadius: "999px",
    border: "none",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    background: "linear-gradient(135deg, #ffffff, #d1d5db)",
    color: "#111",
    transition: "all 0.25s ease",
    boxShadow: "0 10px 30px rgba(255,255,255,0.15)"
  },

  microcopy: {
    marginTop: "12px",
    fontSize: "12px",
    color: "rgba(255,255,255,0.4)"
  },

  gradientOrb1: {
    position: "absolute",
    width: "420px",
    height: "420px",
    background: "radial-gradient(circle, #6366f1, transparent 60%)",
    top: "-120px",
    left: "-120px",
    filter: "blur(120px)",
    opacity: 0.5
  },

  gradientOrb2: {
    position: "absolute",
    width: "420px",
    height: "420px",
    background: "radial-gradient(circle, #22c55e, transparent 60%)",
    bottom: "-140px",
    right: "-140px",
    filter: "blur(120px)",
    opacity: 0.4
  }
};